import React, { useState } from 'react';
import { Box, Button, Tabs, Tab, Typography, Container } from '@mui/material';
import { useRouter } from '@/hooks';
import { ArrowBack } from '@mui/icons-material';
import DownloadIcon from '@mui/icons-material/Download';
import { Hardware } from './Hardware';
import { NetworkSpeed } from './NetworkSpeed';
import { theme } from '@/theme/theme';

interface TabPanelProps {
  children?: React.ReactNode;
  id: number;
  selectedTabId: number;
}

function TabContent(props: TabPanelProps) {
  const { children, selectedTabId, id, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={selectedTabId !== id}
      id={`simple-tabpanel-${id}`}
      aria-labelledby={`simple-tab-${id}`}
      {...other}
    >
      {children}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const SystemRequirement = () => {
  const router = useRouter();

  const tabsData = React.useMemo(
    () => [
      {
        id: 0,
        label: 'Network speed',
        component: <NetworkSpeed />,
      },
      {
        id: 1,
        label: 'Hardware',
        component: <Hardware data-testid="hardware-component" />,
      },
    ],
    []
  );

  const [selectedTabId, setSelectedTabId] = useState(tabsData[0].id);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTabId(newValue);
  };

  return (
    <Box sx={{ height: 'calc(100vh / var(--zoom) - 100px)', overflowY: 'auto', width: '100%' }}>
      <Container>
        <Box data-testid="system-test-dialog" sx={{ mb: 8, mt: 5 }}>
          <Box display="flex" alignItems="center" sx={{ mb: 1 }}>
            <ArrowBack sx={{ mr: 2, cursor: 'pointer' }} onClick={() => router.back()} />
            <Typography variant="h4">System requirement test</Typography>
          </Box>

          <Typography variant="body1" sx={{ color: theme.palette.info.main }}>
            Network and System requirement testing
          </Typography>
        </Box>
        <Box>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Tabs value={selectedTabId} onChange={handleChange}>
              {tabsData.map((tab) => (
                <Tab label={tab.label} {...a11yProps(tab.id)} key={tab.id} />
              ))}
            </Tabs>
            <Button
              variant="contained"
              size="small"
              sx={{
                maxHeight: '44px',
                backgroundColor: '#515151',
                borderRadius: '4px',
              }}
            >
              <DownloadIcon fontSize="small" sx={{ mr: 1 }} />
              Download Report
            </Button>
          </Box>
          {tabsData.map((tab) => (
            <TabContent selectedTabId={selectedTabId} id={tab.id} key={tab.id}>
              {tab.component}
            </TabContent>
          ))}
        </Box>
      </Container>
    </Box>
  );
};
